import React from 'react';
import PropTypes from 'prop-types';
import AutoAffix from 'react-overlays/lib/AutoAffix';
import { last } from 'ramda';

import { createMarkup } from '../../../../../../util/helpers';
import Card from '../../../../../../components/Card/index';
import Progress from '../../../../../../components/Progress/index';

const propTypes = {
  container: PropTypes.any,
  name: PropTypes.string,
  reviews: PropTypes.array,
  percentageComplete: PropTypes.number,
};

const PreRegistrationProgressIndicator = ({ container, name, reviews, percentageComplete }) => {
  const review = last(reviews);
  const showRejectedReview = review && !review.approved;
  const showApprovedReview = review && review.approved && review.message;

  return (
    <div className="col-xs-12 col-sm-4">
      <AutoAffix viewportOffsetTop={10} container={container}>
        <div>
          <Card registration>
            <Card.Header registration>{name} Course Registration</Card.Header>
            <Card.Body>
              <Progress percent={percentageComplete} className="mt-4 mb-2" />
              <p>
                Your registration is <span className="yellow-heading">{percentageComplete}%</span> complete
              </p>
            </Card.Body>
          </Card>
          {showRejectedReview && (
            <Card error className="mt-3">
              <Card.Header>Your registration was rejected. Please review these instructions:</Card.Header>
              <Card.Body className="preWrap">
                <div dangerouslySetInnerHTML={createMarkup(review.message)} />
              </Card.Body>
            </Card>
          )}
          {showApprovedReview && (
            <Card className="mt-3">
              <Card.Header>Your pre-registration was approved with this message:</Card.Header>
              <Card.Body className="preWrap">
                <div dangerouslySetInnerHTML={createMarkup(review.message)} />
              </Card.Body>
            </Card>
          )}
        </div>
      </AutoAffix>
    </div>
  );
};

PreRegistrationProgressIndicator.propTypes = propTypes;

export default PreRegistrationProgressIndicator;
